import { render } from "./Announcement.vue?vue&type=template&id=2a8f26ae&scoped=true&ts=true"
import script from "./Announcement.vue?vue&type=script&lang=ts"
export * from "./Announcement.vue?vue&type=script&lang=ts"

import "./Announcement.vue?vue&type=style&index=0&id=2a8f26ae&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8f26ae"]])

export default __exports__